import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { money } from "../../lib/format";

const Row = ({ label, value, copyValue, id }) => {
  const [done, setDone] = useState(false);
  const copy = () => {
    navigator.clipboard?.writeText(copyValue ?? value);
    setDone(true);
    setTimeout(() => setDone(false), 1800);
  };
  return (
    <div className="flex items-center justify-between gap-3 py-3 border-b border-black/5 last:border-0">
      <div className="min-w-0">
        <p className="text-xs text-slate-500">{label}</p>
        <p className="text-sm font-bold text-slate-800 break-all" data-testid={`transfer-${id}-value`}>{value}</p>
      </div>
      <button onClick={copy} data-testid={`copy-${id}-btn`}
        className={`shrink-0 inline-flex items-center gap-1 px-3 py-2 rounded-full text-xs font-bold transition-colors ${done ? "bg-[#1B4332] text-white" : "bg-[#D8F3DC] text-[#1B4332] hover:bg-[#b7e4c7]"}`}>
        {done ? <Check size={14} /> : <Copy size={14} />} {done ? "Kopyalandı" : "Kopyala"}
      </button>
    </div>
  );
};

export const BankTransfer = ({ banks, balance, resident }) => {
  const [sel, setSel] = useState(0);
  if (!banks.length) return <p className="text-sm text-red-600" data-testid="no-banks">Kayıtlı banka hesabı bulunamadı. Lütfen yönetimle iletişime geçin.</p>;
  const b = banks[sel];
  const desc = `Başkent Sitesi Aidat ${resident.villa_no} ${resident.name || ""}`.trim();
  return (
    <div data-testid="bank-transfer-area">
      <div className="flex flex-wrap gap-2 mb-4">
        {banks.map((x, i) => (
          <button key={x.name + i} onClick={() => setSel(i)} data-testid={`bank-option-${i}`}
            className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${i === sel ? "bg-[#1B4332] text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}>
            {x.name}
          </button>
        ))}
      </div>
      <div className="rounded-2xl bg-[#FDFBF7] border border-black/5 px-4">
        <Row id="holder" label="Alıcı" value={b.account_holder || "Başkent Sitesi Yöneticiliği"} />
        <Row id="iban" label={`IBAN (${b.name})`} value={b.iban || "Tanımlanmamış"} copyValue={(b.iban || "").replace(/\s/g, "")} />
        <Row id="amount" label="Tutar" value={money(balance)} copyValue={balance.toFixed(2).replace(".", ",")} />
        <Row id="desc" label="Açıklama (zorunlu)" value={desc} />
      </div>
      <p className="text-xs text-slate-500 mt-3">Ödemeniz yönetim tarafından hesabınıza işlendiğinde ekstrenizde görünecektir.</p>
    </div>
  );
};
